import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './auth/auth.service';
import { HapticAnchorService } from './services/haptic-anchor.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: `
    @if (auth.isAuthenticated()) {
      <router-outlet />
      @if (haptic.pulseActive()) {
        <!--
          Phase 25 / ADHD Phase 1 — visible chime that fades in on the haptic
          anchor's hourly pulse. Pairs with navigator.vibrate on devices that
          support it; on desktop this IS the felt marker, so the styling
          aims for "noticed at the periphery, not interrupting" — soft fade,
          short dwell.
        -->
        <div class="haptic-chime" role="status" aria-live="polite">
          <span class="haptic-dot" aria-hidden="true"></span>
          <span>Top of the hour</span>
        </div>
      }
    } @else {
      <main class="login">
        <h1>Command Center</h1>
        <button class="btn-primary" (click)="auth.login()">Sign in</button>
      </main>
    }
  `,
  styles: [`
    .login {
      display: grid;
      place-items: center;
      gap: 1rem;
      min-height: 100vh;
      padding: 2rem;
      text-align: center;
      background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
      color: #f8fafc;
    }
    h1 { font-size: 2.5rem; margin: 0; }
    .btn-primary {
      padding: 0.75rem 2rem;
      border-radius: 8px;
      border: 0;
      background: #2563eb;
      color: white;
      font-size: 1rem;
      cursor: pointer;
    }
    .btn-primary:hover { background: #1d4ed8; }

    .haptic-chime {
      position: fixed;
      bottom: 5.5rem;
      right: 1.25rem;
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      padding: 0.45rem 0.9rem;
      border-radius: 999px;
      background: var(--cc-ease-bg, #f0fdfa);
      color: var(--cc-ease-ink, #134e4a);
      border: 1px solid var(--cc-ease-border, #99f6e4);
      font-size: 0.82rem;
      letter-spacing: 0.01em;
      pointer-events: none;
      z-index: 950;
      animation: haptic-fade 3s ease forwards;
    }
    .haptic-dot {
      width: 8px; height: 8px;
      border-radius: 50%;
      background: var(--cc-ease-ink-soft, #0f766e);
      animation: haptic-pulse 1.2s ease-in-out infinite;
    }
    @keyframes haptic-fade {
      0%   { opacity: 0; transform: translateY(8px); }
      10%  { opacity: 1; transform: translateY(0); }
      80%  { opacity: 1; }
      100% { opacity: 0; transform: translateY(-4px); }
    }
    @keyframes haptic-pulse {
      0%, 100% { transform: scale(1); opacity: 1; }
      50% { transform: scale(1.4); opacity: 0.6; }
    }
  `],
})
export class App {
  protected readonly auth = inject(AuthService);
  protected readonly haptic = inject(HapticAnchorService);
}
